import { render, staticRenderFns } from "./CategoriaCreateModal.vue?vue&type=template&id=49584d3c"
import script from "./CategoriaCreateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriaCreateModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports